import { Box } from '@chakra-ui/react';
import { Arrow1Icon, Arrow1OnIcon } from '@halo/ui-chat-react/assets/icons';
import { type PluginProps, useController, useLightboxState } from 'yet-another-react-lightbox';

function ButtonPrev({ isPrev }: { isPrev: boolean }) {
  const { currentIndex, slides } = useLightboxState();
  const { prev, next } = useController();

  const isEnabled = useMemo(() => {
    if (isPrev) return currentIndex > 0;
    return currentIndex < slides.length - 1;
  }, [currentIndex, slides.length, isPrev]);

  const handleClick = useCallback(() => {
    if (!isEnabled) return;
    if (isPrev) {
      prev();
    } else {
      next();
    }
  }, [isEnabled, isPrev, next, prev]);

  return (
    <Box
      position="fixed"
      left={isPrev ? '0' : undefined}
      right={isPrev ? undefined : '0'}
      top="50%"
      transform="translateY(-50%)"
      cursor={isEnabled ? 'pointer' : 'not-allowed'}
      onClick={handleClick}
      display="flex"
      width="34px"
      height="34px"
      alignItems="center"
      justifyContent="center"
    >
      <Box fontSize="8xl" transform={isPrev ? undefined : 'scaleX(-1)'}>
        {isEnabled ? <Arrow1OnIcon color="white" /> : <Arrow1Icon color="#A3A3A3" />}
      </Box>
    </Box>
  );
}

export function PrevNext({ augment }: PluginProps) {
  augment(({ render, ...props }) => ({
    ...props,
    render: {
      ...render,
      buttonPrev: () => <ButtonPrev isPrev={true} />,
      buttonNext: () => <ButtonPrev isPrev={false} />,
    },
  }));
}
